;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.RegistrationFormBuild = Backbone.Model.extend({
		defaults: {
			/*THIS IS REQUIRED BUILDER OPTIONS FOR EVERY EXTENDED REGISTRATION */
			step_count: 1, //Count of steps in registration with out "registration for game"
			steps_chain: ['registrationStep1'],
			steps_layouts: {
				first_step: 'NoSidebar',
				second_step:'NoSidebar',
				games_supported:'NoSidebar',
				join_create_league: 'NoSidebar',
				register_recover: 'NoSidebar'
			},
			steps_views: {
				first_step:  'RegistrationStep1',
				second_step: 'RegistrationStep2',
				games_supported:  'RegisterForGame',
				join_create_league: 'JoinCreateLeague',
				register_recover: 'RegisterRecover'
			},
			first_step_url: 'registration/step_1',  // Url of first step
			first_step_fields: 'first_name,last_name,email,confirm_email,password,passwordConfirm', //First step field in view
			second_step_fields: '', //Second step field in view
			first_step_BE_check: [], // First step backend check
			second_step_BE_check: [],  // Second step backend check
			first_step_buttons: [
				{ text: "Continue", id: "js-submit-step"}
			], //Buttons in first step (you can add more objects in array)
			second_step_buttons: [], //Buttons in first step (you can add more objects in array)
			games_supported: [], //Name of current game TODO::add "all games"
			game_spec_fields: '', //Field for "registration for game" view
			step1_side_bar_widgets: ['Promo', 'Steps' , 'Promo'], //Widgets for first step
			step2_side_bar_widgets: ['Promo', 'Steps' , 'Promo'], //Widgets for second step
			league_model: ''
			/*END REQUIRED BUILDER OPTIONS*/
		}
	});

}(window, APP, Backbone, Marionette, $, _));
